import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { AuthMainComponent } from './core/auth/auth-main/auth-main.component';
import { FarmacoComponent } from './features/dashboard/pages/farmaco/farmaco.component';
import { HeaderComponent } from './features/layout/components/header/header.component';
import { SideBarComponent } from './features/layout/components/side-bar/side-bar.component';
import { LayoutMainComponent } from './features/layout/layout-main/layout-main.component';
import { SettingsComponent } from './features/dashboard/pages/settings/settings.component';
import { NationalComponent } from './features/dashboard/pages/national/national.component';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { SessionExpiredComponent } from './features/dashboard/components/session-expired/session-expired.component';
import { SessionInterceptor } from './core/interceptors/session.interceptor';
import { ToastContainerComponent } from './features/dashboard/components/toast-container/toast-container.component';

@NgModule({
  declarations: [AppComponent],
  providers: [
    provideHttpClient(
      withInterceptors([authInterceptor]),
      withInterceptorsFromDi(),
    ),
    { provide: HTTP_INTERCEPTORS, useClass: SessionInterceptor, multi: true },
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AuthMainComponent,
    FarmacoComponent,
    LayoutMainComponent,
    SideBarComponent,
    HeaderComponent,
    AppRoutingModule,
    SettingsComponent,
    NationalComponent,
    SessionExpiredComponent,
    ToastContainerComponent,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
